import {
  RECEIVE_API_DATA,
  STOP_LOADING,
  REQUEST_HEALTH_CHECK,
  REQUEST_API_SSO_TOKEN, 
  REQUEST_API_GUEST_MAIL, 
  REQUEST_API_GUEST, 
  REQUEST_API_ADD_GUEST, 
  REQUEST_API_ADD_EVENT, 
  REQUEST_API_ADD_GUEST_SPONSOR, 
  REQUEST_API_CONFIRM_BY_SPONSOR,
  REQUEST_API_CONFIRM_BY_GUEST,
  REQUEST_API_CONFIRM_SPONSOR,
  REQUEST_API_CONFIRM_GUEST,
  REQUEST_API_GUESTS
  
} from "../actions/actions";

export default (state = { }, { type, data }) => {
  switch (type) {
    case STOP_LOADING:
      return { ...state, loading: false };
    case RECEIVE_API_DATA:
      return { ...state, ...data, loading: false };
    case REQUEST_HEALTH_CHECK:
      return { loading : true }; 
    case REQUEST_API_SSO_TOKEN:
      return {...data, loading: true };
    case REQUEST_API_GUEST_MAIL:
      return {...data, loading: true };
    case REQUEST_API_ADD_GUEST:
      return {...data, loading: true };
    case REQUEST_API_ADD_GUEST_SPONSOR:
      return {...data, loading: true };
    case REQUEST_API_ADD_EVENT:
      return {...data, loading: true };
    case REQUEST_API_CONFIRM_BY_SPONSOR:
      return {...data, loading: true };
    case REQUEST_API_CONFIRM_BY_GUEST:
      return {...data, loading: true };
    case REQUEST_API_CONFIRM_SPONSOR:
      return {...data, loading: true };
    case REQUEST_API_CONFIRM_GUEST:
      return {...data, loading: true };
    case REQUEST_API_GUEST: 
      return {...data, loading: true };
    case REQUEST_API_GUESTS: 
      return {...data, loading : true };
    default:
      return state;
  }
};
